export function NotFound(): JSX.Element {
    return (
        <div>
            Not found
        </div>
    );
}
